import clsx from 'clsx';

import GtlLogoLarger from '@/assets/images/gtl-logo-larger.png';
import IconGo2Light from '@/assets/images/icon-go2-light.png';

interface SidebarHeaderProps {
  collapsed: boolean;
}

export const SidebarHeader = ({ collapsed }: SidebarHeaderProps) => {
  return (
    <div
      className={clsx(
        'flex items-center border-b border-[#4b545c] px-4 py-3',
        collapsed && 'justify-center',
      )}
    >
      <figure>
        {!collapsed ? (
          <img src={GtlLogoLarger} className="h-[30px] w-auto" alt="Logo" />
        ) : (
          <img src={IconGo2Light} className="h-[30px] w-[30px]" alt="Logo" />
        )}
      </figure>
    </div>
  );
};
